var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Drawer, makeStyles, useMediaQuery } from "@material-ui/core";
import FTLPopper from "./FTLPopper";
import FTLPaper from "./FTLPaper";
import clsx from "clsx";
export default React.forwardRef((_a, ref) => {
    var _b;
    var { children, anchorEl, className, menuWidth, menuHeight = "auto", open = true, disableMargin, onClose } = _a, otherProps = __rest(_a, ["children", "anchorEl", "className", "menuWidth", "menuHeight", "open", "disableMargin", "onClose"]);
    const classes = useStyles({
        menuWidth: menuWidth ? menuWidth : (_b = anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.clientWidth) !== null && _b !== void 0 ? _b : "auto",
        menuHeight,
    });
    const mobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    return mobile ? (React.createElement(Drawer, Object.assign({ anchor: "bottom", open: open, className: clsx(className, classes.menu), disableEnforceFocus: true, elevation: 0, role: "listbox", "aria-selected": open, tabIndex: -1, onClose: onClose }, otherProps), children)) : (React.createElement(FTLPopper, Object.assign({ ref: ref, open: open, className: clsx(className, classes.menu), anchorEl: anchorEl, "aria-selected": open, tabIndex: -1 }, otherProps),
        React.createElement(FTLPaper, { disableMargin: disableMargin, role: "listbox" }, children)));
});
const useStyles = makeStyles({
    menu: ({ menuWidth, menuHeight, }) => ({
        width: menuWidth,
        height: menuHeight,
    }),
});
//# sourceMappingURL=FTLDropdownMenu.js.map